<template>
  <div>
    <!-- 新增、删除按钮及搜索框 -->
    <el-row type="flex" justify="space-between" align="middle" class="tool-tips">
      <el-col>
        <el-button type="primary" @click="handleAdd">新增</el-button>
        <el-button type="danger" @click="handleDeleteBatch">批量删除</el-button>
      </el-col>
      <el-col align="right">
        <!-- 这里@keyup.enter需要加上native -->
        <el-form :inline="true"  class="demo-form-inline" style="display: inline; width: 200px;">
            <el-form-item label="分类">
                <el-cascader
                    ref="cascaderRef"
                    class="cascader"
                    v-model="selectedCategoryKeys"
                    :options="category"
                    :props="props"
                    :placeholder="default_folder_category.label"
                    @change="parentCateChanged"
                    >
                </el-cascader>
            </el-form-item>
        </el-form>
        <el-input
          v-model="searchValue"
          placeholder="请输入搜索内容"
          class="input-with-select"
          @keyup.enter.native="handleSearch"
        >
          <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
        </el-input>
      </el-col>
    </el-row>
    <!-- 表格 -->
    <el-table :data="tableData" tooltip-effect="dark" @selection-change="handleSelectionChange">
      <el-table-column type="selection" align="center"></el-table-column>
      <!-- 当内容过长被隐藏时显示 tooltip -->
      <el-table-column width="200px" label="商品" align="center" prop="info_lang" show-overflow-tooltip>
        <template slot-scope="scope">
          <div class="cover-name" style="display: flex;align-items: center;">
            <img class="good-img" :src="scope.row.cover.startsWith('/')?`${baseURL}${scope.row.cover}`:scope.row.cover.startsWith('http')?`${scope.row.cover}`:`${baseURL}/${scope.row.cover}`" />
            <div>
              <div class="good-name">{{ scope.row.name_lang }}</div>
              <span class="good-id" style="display: block;">编号:{{scope.row.id}}</span>
            </div>
          </div>
          <!-- <el-row type="flex" align="left">
            
            
            <div>
              <div class="good-name" style="display: block;">{{ scope.row.info_lang }}</div>
              <span class="good-id" style="display: block;">编号:{{scope.row.id}}</span>
            </div>
          </el-row> -->
        </template>
      </el-table-column>
      <el-table-column prop="category_str" align="center" label="分类"></el-table-column>
      <el-table-column width="100px" prop="price" align="center" label="价格"></el-table-column>
      <!-- 能否用:prop的method(add_time)格式化 -->
      <el-table-column prop="create_update_time_str" align="center" label="创建/修改时间"></el-table-column>
      <!-- <el-table-column prop="update_time_str" align="center" label="最后修改时间"></el-table-column> -->
      <el-table-column width="100px" label="启用开关" align="center" prop="state_bool">
        <template #default="{row}">
          <el-switch
            v-model="row.state_bool"
            active-color="#13ce66"
            inactive-color="#A3A3A3"
            :key="row.id"
            @change="switch_change(row)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          
          <el-button type="primary" @click="handleEdit(scope.row)" icon="el-icon-edit" circle></el-button>
          <el-button type="danger" @click="handleDelete(scope.row)" icon="el-icon-delete" circle></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[2, 4, 8, 16]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalcount"
      class="pagination"
    ></el-pagination>
  </div>
</template>

<script>
import { all_category_list, baseURL, delete_goods, edit_goods, goods_list } from '../api/api';
import { getYMDHMS } from '../utils';
import { SystemStore } from "../store";
export default {
  data() {
    return {
      baseURL,
      state:true,
      // 表格数据
      tableData: [],
      // 批量删除商品的id
      ids: [],
      category_id:SystemStore().getCategoryId,
      // 搜索框的值
      searchValue: "",
      // 分页器当前页
      currentPage: SystemStore().getCurrentPage,
      // 每页的商品数
      pageSize: 8,
      // 总商品数
      totalcount: 0,
      category:SystemStore().getTotalCategories,
      default_folder_category:{
            value:0,
            id:0,
            name:'默认分类',
            name_lang:'默认分类',
            label:'默认分类'
      },
      selectedCategoryKeys:SystemStore().getCategories.map(item=>item.value),//[0],
      newCategoryName:'',
      props: {
        checkStrictly: true, // 允许父节点单独选中
      }
    };
  },

  methods: {
    parentCateChanged(e,v){
            SystemStore().update_current_page(1)
            this.currentPage = 1;
            this.category_id = this.selectedCategoryKeys[this.selectedCategoryKeys.length - 1]
            this.$refs.cascaderRef.toggleDropDownVisible(false)
            this.getGoodsList()
            SystemStore().change_category(this.category_id)
            // console.log('parentCateChanged',e,v,this.selectedCategoryKeys,this.category_id)
            // md5()
    },
    // 点击新增
    handleAdd() {
      // 跳转新增页面
      this.$router.push("./goodsadd");
    },
    async get_all_categories(){

      const categories_res = await all_category_list()
      console.log('good-categories_res',categories_res)
      if(!categories_res.tree.length){
        categories_res.tree = []
      }
      categories_res.tree.unshift(this.default_folder_category);
      this.category = categories_res.tree
      this.categorysKeyAddForEach(this.category)  
    },
    categorysKeyAddForEach(arr){
            arr.forEach(item=>{
                item.value = item.id;
                item.label = item.name_lang;
                if(item.children && item.children.length){
                    this.categorysKeyAddForEach(item.children)
                }else if(item.children){
                    Reflect.deleteProperty(item, 'children');
                }
            })
            SystemStore().update_all_categories(arr)
    },
    // 批量删除
    handleDeleteBatch() {
      // 将所有id变成以","分隔的字符串 如1,2,3
      const ids = this.ids.join(",");
      // 如果字符串为空，以为这还没选择任一商品
      if (!ids) {
        // 弹框提示
        this.$message({
          type: "warning",
          message: "您还没选择任何商品呢"
        });
        return;
      }
      // 弹窗确认框
      this.$confirm("是否删除所选商品?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          // 确定则发送删除请求
          //   获取id
          delete_goods(ids)
          .then(res=>{
            this.$message({
              type: "success",
              showClose: true,
              message: `删除成功`,
            });
             // 重新获取数据
             this.getGoodsList();
          })
          .catch(err=>{
            this.$message({
              showClose: true,
              message: err,
              type:"error"
            })
          })
        })
        .catch(() => {
          // 取消的时候什么都不做
        });
    },
    // 搜索
    handleSearch() {
      // 根据搜索值获取商品
      this.getGoodsList();
    },
    handleSelectionChange(val) {
      // val为选择的行
      var ids = val.map(v => v.id);
      this.ids = ids;
    },
    // 编辑商品
    handleEdit(val) {
      // 点击编辑获取商品的id
      const { id } = val;
      // 跳转到编辑页面
      this.$router.push(`./GoodsEdit/${id}`);
    },

    // 删除单行数据
    handleDelete(val) {
      // 弹窗确认框
      this.$confirm(`是否删除${val.name_lang}?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          // 确定则发送删除请求
          //   获取id
          const { id } = val;
          delete_goods(id)
          .then(res=>{
            this.$message({
              type: "success",
              showClose: true,
              message: `删除成功`,
            });
             // 重新获取数据
             this.getGoodsList();
          })
          .catch(err=>{
            this.$message({
              showClose: true,
              message: err,
              type:"error"
            })
          })
        
        })
        .catch(() => {
          // 取消的时候什么都不做
        });
    },
    // 每页条数改变的时候
    handleSizeChange(val) {
      // 重新改变每页条数
      this.pageSize = val;
      // 并重新获取数据
      this.getGoodsList();
    },
    // 当前页改变的时候
    handleCurrentChange(val) {
      // 修改当前页
      this.currentPage = val;
      // 并重新获取数据
      this.getGoodsList();

      SystemStore().update_current_page(this.currentPage)

      localStorage.setItem('goodlistpage', this.currentPage)
    },
    // 获取商品
    getGoodsList() {
      // 发起获取商品请求
      goods_list(this.searchValue,0,this.category_id,this.currentPage,this.pageSize)
      .then(res=>{
        console.log('list',res)
        this.tableData = res.list
        this.totalcount = res.total;
        this.timeformat(this.tableData)
        // this.totalcount = res.data.totalcount;
      })
    },
    timeformat(list){
      list.forEach(good => {
        good.create_time_str = getYMDHMS(good.create_time*1000)
        good.create_update_time_str = good.create_time_str
        if(good.update_time)
        {
          good.update_time_str = getYMDHMS(good.update_time*1000)
          good.create_update_time_str = good.update_time_str
        }
       
        good.state_bool = good.state == 1?true:false;
      });
    },
    switch_change(e){
  
      e.state = e.state_bool == true?1:2
      const index = this.tableData.indexOf(e)
       //ui 解决state_bool变化无反应的问题
      this.$set(this.tableData,index,{...e,status:e.state_bool})

      edit_goods(e)
      .catch(err=>{
        e.state_bool = !e.state_bool
        this.$message({
          showClose: true,
          message: err,
          type:"error"
        })
      })
    }
  },
  mounted() {
    //   页面加载成功后获取商品列表
    this.getGoodsList();
    this.get_all_categories()
  }
};
</script>

<style lang="less" scoped>
.tool-tips {
  margin: 20px 0;

  .input-with-select {
    width: 50%;
  }
}
.el-select .el-input {
  width: 130px;
}

.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.cover-name{
  height: 100%;
}
.good-img {
  width: 60px;
  padding: 0 10px;
}

.good-name{
  font-weight: bold;
  font-size: 16px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* 限制行数为2 */
  overflow: hidden;
  text-overflow: ellipsis;
}

.good-id{
  font-size: 12px;
  color:rgb(135, 140, 151);
  text-align: left;
}

.pagination {
  margin-top: 20px;
}
</style>